import React from "react";

import ChipOnTable from "../../../chip/chip-on-table";
import {BetType} from "../../../../enums/tableNumbers";
export const MobileRectangleTableLeft = ({
                                           allChipsTypes,
                                           handleGetColumnChip,
                                           winNumber
                                         }) => {
  const straightUp_0_Chip = handleGetColumnChip(BetType.StraightUp_0);
  const Street_0_1_2_Chip = handleGetColumnChip(BetType.Street_0_1_2);
  const Street_0_2_3_Chip = handleGetColumnChip(BetType.Street_0_2_3);
  const Corner_0_1_2_3_Chip = handleGetColumnChip(BetType.Corner_0_1_2_3);

  return (
    <div className="mob-roulette-t-right-top">
      <div className={`mob-game-box ${winNumber === 0 ? 'win' : ''}`} data={BetType.StraightUp_0}>
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
             viewBox="0 0 168.9 46.3">

          <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="84.44" y1="-59.6814"
                          x2="84.44" y2="108.1986"
                          gradientTransform="matrix(6.123234e-17 1 1 -6.123234e-17 60.1814 -61.3014)">
            <stop offset="0" stopColor="#003E02"/>
            <stop offset="1" stopColor="#007E51"/>
          </linearGradient>
          <path className="st0" d="M168.4,45.8V22.1c0-1.6-1.1-3-2.7-3.3L86.1,0.9c-0.3-0.1-0.6-0.2-0.9-0.2c-1.2-0.2-2.5-0.2-3.8,0.1L4.7,18.5
	                            c-2.5,0.6-4.2,2.8-4.2,5.3v22L168.4,45.8z"/>
        </svg>
        0
        <div className="r-click click_0-2-3" data={BetType.Street_0_2_3}>
          <ChipOnTable
            type={BetType.Street_0_2_3}
            columnChips={Street_0_2_3_Chip}
            allChipsTypes={allChipsTypes}
          />
        </div>
        <div className="r-click click_0-1-2" data={BetType.Street_0_1_2}>
          <ChipOnTable
            type={BetType.Street_0_1_2}
            columnChips={Street_0_1_2_Chip}
            allChipsTypes={allChipsTypes}
          />
        </div>
        <div className="r-click click_0-1" data={BetType.Corner_0_1_2_3}>
          <ChipOnTable
            type={BetType.Corner_0_1_2_3}
            columnChips={Corner_0_1_2_3_Chip}
            allChipsTypes={allChipsTypes}
          />
        </div>
        <ChipOnTable
          type={BetType.StraightUp_0}
          columnChips={straightUp_0_Chip}
          allChipsTypes={allChipsTypes}
        />
      </div>
    </div>
  );
};
